import { render, staticRenderFns } from "./bs_layout_visible.vue?vue&type=template&id=067e39af"
import script from "./bs_layout_visible.vue?vue&type=script&lang=js"
export * from "./bs_layout_visible.vue?vue&type=script&lang=js"
import style0 from "./bs_layout_visible.vue?vue&type=style&index=0&id=067e39af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports